@if(initialized){
    <mvs-widget *ngIf="contractWidgetData"
                [widgetData]="contractWidgetData"
    ></mvs-widget>
}
